import { render, staticRenderFns } from "./PatientsAppointments.vue?vue&type=template&id=af6a5018"
import script from "./PatientsAppointments.vue?vue&type=script&lang=js"
export * from "./PatientsAppointments.vue?vue&type=script&lang=js"
import style0 from "./PatientsAppointments.vue?vue&type=style&index=0&id=af6a5018&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports